var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wechatIcon",on:{"click":_vm.jumpConsult}},[_c('img',{staticClass:"fixedIcon",attrs:{"src":_vm.fw},on:{"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave}}),(_vm.showQrcode)?_c('div',{staticClass:"popover"},[_c('img',{attrs:{"src":_vm.qrcode}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }